// src/scripts/colorCodes.js
//
// Frontend mirror of backend/lib/colorCodes.js — Phase 3 single source
// of truth. Keep these two files in lockstep when adding / renaming a
// status. (No automated check yet; a Phase 4 build-time test could diff
// them via the API to enforce parity.)

export const COLOR_CODES = [
  { code: 0,  label: "Unassigned",                 slug: "unassigned",            category: "other" },
  { code: 1,  label: "Sold",                       slug: "sold",                  category: "delivered",  hex: "#C757FF", fg: "#ffffff" },
  { code: 2,  label: "Rented Out",                 slug: "rented_out",            category: "in_stock",   hex: "#FFD966", fg: "#000000" },
  { code: 3,  label: "In Stock - Calgary",         slug: "in_stock_calgary",      category: "in_stock",   hex: "#00B050", fg: "#ffffff" },
  { code: 4,  label: "In Transit to Calgary",      slug: "in_transit_to_sna",     category: "in_transit", hex: "#92D050", fg: "#000000" },
  { code: 5,  label: "In Transit to Customer",     slug: "in_transit_to_customer",category: "in_transit", hex: "#FF8A65", fg: "#ffffff" },
  { code: 6,  label: "Alert",                      slug: "alert",                 category: "alert",      hex: "#FF0000", fg: "#ffffff" },
  { code: 7,  label: "To Order",                   slug: "to_order",              category: "on_order",   hex: "#FFCCFF", fg: "#000000" },
  { code: 8,  label: "On Order",                   slug: "on_order",              category: "on_order",   hex: "#FFCCFF", fg: "#000000" },
  { code: 9,  label: "Stock & PDI - In Calgary",   slug: "stock_and_pdi",         category: "in_stock",   hex: "#92D050", fg: "#000000" },
  { code: 10, label: "Demo",                       slug: "demo",                  category: "in_stock",   hex: "#A78BFA", fg: "#ffffff" },
  { code: 11, label: "Chassis Allocation Slot",    slug: "chassis_allocation",    category: "on_order",   hex: "#94A3B8", fg: "#ffffff" },
  { code: 12, label: "Ready at Factory",           slug: "ready_at_factory",      category: "on_order",   hex: "#FBBF24", fg: "#000000" },
  { code: 13, label: "In Transit - Broke Down",    slug: "broke_down",            category: "alert",      hex: "#DC2626", fg: "#ffffff" },
];

const BY_CODE = new Map(COLOR_CODES.map((c) => [c.code, c]));
const BY_SLUG = new Map(COLOR_CODES.map((c) => [c.slug, c]));

export function getColorCode(input) {
  if (input == null || input === "") return null;
  const n = Number(input);
  if (Number.isFinite(n) && BY_CODE.has(n)) return n;
  const s = String(input).toLowerCase().trim();
  if (BY_SLUG.has(s)) return BY_SLUG.get(s).code;
  for (const c of COLOR_CODES) {
    if (c.label.toLowerCase() === s) return c.code;
  }
  return null;
}

export function getStatusLabel(input) {
  const code = getColorCode(input);
  return code == null ? "" : BY_CODE.get(code).label;
}

export function getStatusSlug(input) {
  const code = getColorCode(input);
  return code == null ? "" : BY_CODE.get(code).slug;
}

export function getStatusEntry(input) {
  const code = getColorCode(input);
  return code == null ? null : BY_CODE.get(code);
}

// Convenience for status pills/chips: returns { bg, fg, label } or null.
export function getStatusBadge(input) {
  const e = getStatusEntry(input);
  if (!e) return null;
  return { bg: e.hex || "#94A3B8", fg: e.fg || "#ffffff", label: e.label };
}

// Backwards-compat: { 0: 'Unassigned', 1: 'Sold', … }
export const STATUS_LABELS = Object.fromEntries(
  COLOR_CODES.map((c) => [c.code, c.label])
);
